var slider = {
	selectors: { 
		sliders: [
			'[data-slider]',
			'.wc-block-product-categories-list',
		]
	},

	init: function () {
		var self = this;

		jQuery.each( self.selectors.sliders, function( index, item ){

			if( jQuery( item ).length ) {
				jQuery( item ).each(function(){
	
					var items = jQuery( this ).attr( 'data-items' ) ? jQuery( this ).attr( 'data-items' ) : 4;
					var itemsMobile = jQuery( this ).attr( 'data-itemsMobile' ) ? jQuery( this ).attr( 'data-itemsMobile' ) : 2;
					var autoplay = jQuery( this ).attr( 'data-autoplay' ) ? jQuery( this ).attr( 'data-autoplay' ) : false;
	
					if( item == '.wc-block-product-categories-list' ) {
						items = 6;
						itemsMobile = 3;
						autoplay = true;

						jQuery( this ).find( '.wc-block-product-categories-list-item' ).removeClass( 'wc-block-product-categories-list-item' );
						jQuery( this ).find( '.wc-block-product-categories-list-item__image' ).attr( 'class', 'thumbnail' );
					}

					let sliderClass =  'slider-' + (Math.random() + 1).toString(36).substring(7);
					jQuery( this ).addClass( sliderClass );
	
					var slider = tns({
						container: `.${sliderClass}`,
						items: items,
						gutter: 20,
						loop: true,
						autoplay: autoplay,
						responsive: {
							  300: {						
								items: itemsMobile
							  },
							  990: {
								items: items
							}
						}
					});
	
				});
			}

		});
	},
};

export { slider };
